import(/* webpackMode: "eager", webpackExports: ["SimulatePreloadedQuery"] */ "/vercel/path0/node_modules/@apollo/client-react-streaming/dist/index.cc.js");
;
import(/* webpackMode: "eager", webpackExports: ["ClientRouteMetadataSetter"] */ "/vercel/path0/packages/lesswrong/components/ClientRouteMetadataContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["withAddClasses"] */ "/vercel/path0/packages/lesswrong/components/hooks/useStyles.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/lesswrong/components/posts/PostsSingle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PostsPageHeaderTitle"] */ "/vercel/path0/packages/lesswrong/components/titles/PostsPageHeaderTitle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Link"] */ "/vercel/path0/packages/lesswrong/lib/reactRouterWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LocationContext","SubscribeLocationContext","NavigationContext","Consumer"] */ "/vercel/path0/packages/lesswrong/lib/vulcan-core/appContext.ts");
